export { default } from "./SearchModalResult";
